
export const systemEditionNav = [
    {url: '/system/landing', label: 'Landing page', key: 'landing.index', permissions: []},
    {url: '/system/landing/create', label: 'Landing block create', key: 'landing.block.create', parent_key: 'landing.index', permissions: []},
    {url: '/system/landing/[id]', label: 'Landing block', key: 'landing.block', parent_key: 'landing.index', permissions: []},
]